import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TotpConfirmResult, TotpEnrollment } from '@models';

@Injectable({ providedIn: 'root' })
export class TotpService {
  private http = inject(HttpClient);

  enroll() {
    return this.http.post<TotpEnrollment>('clients/v1/auth/totp/enroll', {});
  }

  confirm(totp: string) {
    return this.http.post<TotpConfirmResult>('clients/v1/auth/totp/confirm', { totp });
  }

  verifyCurrent(totp: string) {
    return this.http.post('clients/v1/auth/totp/verify-current', { totp });
  }
}
